import { put, race, take, takeLatest } from 'redux-saga/effects';

import * as inviteGuest from '../requests/invite-guest-to-virtual-room-req';
import * as success from '../../ui/success';

export function* inviteGuestSagaWorker({ payload }) {
  const { close, ...params } = payload;
  yield put(inviteGuest.actions.send(params));

  const { succeed } = yield race({
    succeed: take(inviteGuest.actions.succeed),
    failed: take([
      inviteGuest.actions.rejected,
      inviteGuest.actions.errorEncountered,
    ]),
  });

  if (succeed) {
    close();
    yield put({
      type: success.consts.UPDATE,
      payload: { id: 'virtualVisit.room.sentInvitation' },
    });
  }
}

export default function* inviteGuestSaga() {
  yield takeLatest(inviteGuest.actions.init, inviteGuestSagaWorker);
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/invite-quest-to-virtual-room-saga.js